import { useMemo, useState } from 'react';
import { List, TextField, FunctionField, useTranslate } from 'react-admin';
import { CustomDatagrid, CrudListActions, RowActionsMenu } from '@/components/common';
import { compactListSx } from '@/components/common/compactListSx';
import {
  CollapsibleFilterPanel,
  FilterExpandContext,
} from '@/components/common/CollapsibleFilterPanel';
import { CustomTextInputFilter } from '@/components/common/CustomFilters';

export const PlanList = () => {
  const translate = useTranslate();
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const filterExpandValue = useMemo(
    () => ({ expanded: filtersExpanded, setExpanded: setFiltersExpanded }),
    [filtersExpanded]
  );

  const filters = useMemo(
    () => [
      <CollapsibleFilterPanel key="filters" source="_cfp" alwaysOn alwaysVisibleCount={0}>
        <CustomTextInputFilter
          source="q"
          label={translate('common.filters.search', { _: 'Buscar' })}
          alwaysOn
        />
      </CollapsibleFilterPanel>,
    ],
    [translate]
  );

  return (
    <FilterExpandContext.Provider value={filterExpandValue}>
      <List
        sx={compactListSx}
        filters={filters}
        actions={<CrudListActions exportColumns={['name', 'plan_type', 'price', 'duration', 'static_qr_limit', 'dynamic_qr_limit', 'staff_member_limit']} />}
        sort={{ field: 'plan_id', order: 'DESC' }}
        exporter={false}
      >
        <CustomDatagrid primarySource="name" secondarySource="plan_type" bulkActionButtons={false}>
          <RowActionsMenu label="" sortable={false} />
          <TextField source="name" />
          <FunctionField
            source="plan_type"
            render={(record: any) =>
              translate(`resources.plans.types.${record?.plan_type}`, { _: record?.plan_type })
            }
          />
          <FunctionField source="price" render={(record: any) => `${record?.price} €`} />
          <FunctionField
            source="duration"
            render={(record: any) =>
              record?.duration === 365
                ? translate('resources.plans.durations.yearly')
                : translate('resources.plans.durations.monthly')
            }
          />
          <TextField source="static_qr_limit" />
          <TextField source="dynamic_qr_limit" />
          <TextField source="staff_member_limit" />
        </CustomDatagrid>
      </List>
    </FilterExpandContext.Provider>
  );
};

export default PlanList;
